import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { FloatingCTA } from "./components/FloatingCTA";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { CookieBanner } from "./components/CookieBanner";
import { PflegegradRechner } from "./components/PflegegradRechner";
import Home from "./pages/Home";
import Leistungen from "./pages/Leistungen";
import UeberUns from "./pages/UeberUns";
import Kontakt from "./pages/Kontakt";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import StadtSeite from "./pages/StadtSeiteV2";
import Ratgeber from "./pages/Ratgeber";
import BlogPost from "./pages/BlogPost";
import Kosten from "./pages/Kosten";
import PflegeNotfall from "./pages/PflegeNotfall";
import { Pflegegrad1, Pflegegrad2, Pflegegrad3, Pflegegrad4, Pflegegrad5 } from "./pages/PflegegradSeiten";
import Grundpflege from "./pages/Grundpflege";
import Behandlungspflege from "./pages/Behandlungspflege";
import Demenzbetreuung from "./pages/Demenzbetreuung";
import PflegeZuhauseVsPflegeheim from "./pages/PflegeZuhauseVsPflegeheim";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen flex flex-col">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <div className="flex-1">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/leistungen" element={<Leistungen />} />
              <Route path="/ueber-uns" element={<UeberUns />} />
              <Route path="/kontakt" element={<Kontakt />} />
              <Route path="/kosten" element={<Kosten />} />
              <Route path="/pflege-notfall" element={<PflegeNotfall />} />
              <Route path="/pflegegrad-1" element={<Pflegegrad1 />} />
              <Route path="/pflegegrad-2" element={<Pflegegrad2 />} />
              <Route path="/pflegegrad-3" element={<Pflegegrad3 />} />
              <Route path="/pflegegrad-4" element={<Pflegegrad4 />} />
              <Route path="/pflegegrad-5" element={<Pflegegrad5 />} />
              <Route path="/grundpflege" element={<Grundpflege />} />
              <Route path="/behandlungspflege" element={<Behandlungspflege />} />
              <Route path="/demenzbetreuung" element={<Demenzbetreuung />} />
              <Route path="/pflege-zuhause-vs-pflegeheim" element={<PflegeZuhauseVsPflegeheim />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/ratgeber" element={<Ratgeber />} />
              <Route path="/ratgeber/:slug" element={<BlogPost />} />
              {/* Lokale Landing Pages für SEO */}
              <Route path="/ambulante-pflege/:stadt" element={<StadtSeite />} />
            </Routes>
          </div>
          <Footer />
          
          {/* Floating Elements */}
          <FloatingCTA />
          <WhatsAppButton />
          <PflegegradRechner />
          <CookieBanner />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
